import { useRef } from "react";

import type {
  ModuleDetailDto,
  PriceCategoryListItemDto,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { ModuleForm, type ModuleFormHandle } from "Modules/Forms/ModuleForm";
import type { ModuleFormData } from "Modules/Forms/moduleFormSchema";
import { BlModal } from "Shared/Dialogs/BlModal";

interface EditModuleModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (data: ModuleFormData) => void;
  module: ModuleDetailDto;
  priceCategories: PriceCategoryListItemDto[];
  isPriceCategoriesLoading?: boolean;
  serverError?: Error | null;
}

export const EditModuleModal = ({
  isOpen,
  onClose,
  onConfirm,
  module,
  priceCategories,
  isPriceCategoriesLoading,
  serverError,
}: EditModuleModalProps): React.ReactNode => {
  const { t } = useResource();
  const formRef = useRef<ModuleFormHandle | null>(null);

  const handleClose = () => {
    formRef.current?.reset();
    onClose();
  };

  return (
    <BlModal
      isOpen={isOpen}
      title={t(Resources.Modules.EditModuleModal.Title)}
      onCancel={handleClose}
      onConfirm={() => formRef.current?.submit(onConfirm)()}
      cancelButtonText={t(Resources.Common.Cancel)}
      confirmButtonText={t(Resources.Modules.EditModuleModal.Save)}
      maxWidth="800px"
    >
      <ModuleForm
        module={module}
        priceCategories={priceCategories}
        isPriceCategoriesLoading={isPriceCategoriesLoading}
        formRef={formRef}
        serverError={serverError}
      />
    </BlModal>
  );
};
